var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRosbank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rosbank"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 11.61H2.5V11H1V19H19V11H17.5V11.61ZM3.5 10V10.61H16.5V10H20V20H0V10H3.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0H0V10H3.5V9.38998H16.5V10H20V0Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRosbank);
export default __webpack_public_path__ + "static/media/rosbank.f8bbe927127001f82d5ab55521a31a05.svg";
export { ForwardRef as ReactComponent };